export default {
  'invoiceCarrier.title': 'ตัวนำส่งใบเสร็จ',
  'invoiceCarrier.error.format.one':
    'รูปแบบบาร์โค้ดตัวนำส่งใบเสร็จไม่ถูกต้อง เช่น ไม่มีการกรอก / หรือความยาวสตริงไม่ถูกต้อง',
  'invoiceCarrier.error.format.two':
    'กรุณากรอกบาร์โค้ดตัวนำส่งที่ขึ้นต้นด้วย / (ตัวอย่าง: /A123456)',
  'invoiceCarrier.save': 'บันทึก',
  'invoiceCarrier.setting_complete': 'ตั้งค่าบาร์โค้ดตัวนำส่งเสร็จสิ้น',
} as Record<string, string>;
